import PublicLayout from './layouts/PublicLayout';
import { RouterProvider, createBrowserRouter, Navigate } from 'react-router-dom'
import { getLocale, isUserLoggedIn } from './utils';
import LoginPage from 'features/auth/login';
import AdminLayout from './layouts/AdminLayout';
import NotFound from './features/misc/NotFound';
import { useEffect } from 'react';
import { setUiLocale } from 'app/i18n';
import { ConfigProvider } from 'antd';
import { useTranslation } from 'react-i18next';
import FillInfo from 'features/auth/fill-info';
import ListUser from 'features/user';
import SettingNotification from 'features/notification';
import ListConfirmQr from 'features/confirm-qr';
import SuccessConfirm from 'features/confirm-qr/Success';
import LotteryPage from 'features/lottery';
import PrizeManagement from 'features/prize';
function App() {

  useEffect(() => {
    setUiLocale(getLocale() || process.env.REACT_APP_DEFAULT_LOCALE)
  }, [])

  const { t } = useTranslation()

  const router = createBrowserRouter([
    {
      path: "/",
      element: !isUserLoggedIn() ? <Navigate to='/fill-info' /> : <Navigate to='/manager' />,
    },
    {
      path: "/fill-info",
      element: <PublicLayout />,
      children: [
        {
          index: true,
          element: <FillInfo />
        }
      ]
    },
    {
      path: "/login",
      element: <PublicLayout />,
      children: [
        {
          index: true,
          element: <LoginPage />
        }
      ]
    },
    {
      path: "/confirm-success",
      element: <PublicLayout />,
      children: [
        {
          index: true,
          element: <SuccessConfirm />
        }
      ]
    },
    {
      path: "/manager",
      element: <AdminLayout />,
      children: [
        {
          index: true,
          element: <ListUser />
        },
        {
          path: 'confirm-qr',
          element: <ListConfirmQr />
        },
        {
          path: "setting-condition",
          element: <SettingNotification />
        },
        {
          path: "prize",
          element: <PrizeManagement />
        },
      ]
    },
    {
      path: "lottery",
      element: <LotteryPage />
    },
    {
      path: "*",
      element: <NotFound />
    }
  ]);

  return (
    <ConfigProvider form={{
      validateMessages: {
        required: t('required')
      }
    }}>
      <RouterProvider router={router} />
    </ConfigProvider>
  )
}

export default App
